import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { useAvailableDates } from '../../redux/slices/appContext'
import DateTimePicker from '../atoms/DateTimePicker'
import useAvailableDatesDefault from '../../hooks/useAvailableDatesDefault'
import { disableWeekends } from '../../utils'
import { AVAILABLE_DATA_TYPE, DATE_TIME_PICKER_TYPES } from '../../constants'

const AvailableDatePicker = ({
  disableFuture,
  extraStyles,
  format,
  label,
  onChange,
  type,
  value,
  className,
  shouldDisableWeekends,
  disableCalendar
}) => {
  const [availableDates, loadingAvailableDates] = useAvailableDates()
  const componentExtraStyles = { ...(extraStyles || {}), width: '100%' }
  const { maxDate: defaultValue, maxDate, minDate } = useAvailableDatesDefault(availableDates)

  return (
    <DateTimePicker
      type={type}
      value={value}
      label={label}
      format={format}
      onChange={onChange}
      className={className}
      defaultValue={defaultValue}
      disableFuture={disableFuture}
      disabled={loadingAvailableDates || disableCalendar}
      extraStyles={componentExtraStyles}
      disabledDateRange={{ min: minDate, max: maxDate }}
      {...(shouldDisableWeekends ? { shouldDisableDate: disableWeekends } : {})}
    />
  )
}

AvailableDatePicker.propTypes = {
  availableDataType: PropTypes.oneOf(Object.values(AVAILABLE_DATA_TYPE)),
  disableFuture: PropTypes.bool,
  extraStyles: PropTypes.any,
  format: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.oneOf(Object.values(DATE_TIME_PICKER_TYPES)),
  value: PropTypes.string,
  shouldDisableWeekends: PropTypes.bool,
  className: PropTypes.string,
  disableCalendar: PropTypes.bool
}

AvailableDatePicker.defaultProps = {
  availableDataType: AVAILABLE_DATA_TYPE.cash,
  disableFuture: false,
  extraStyles: undefined,
  format: 'MM/DD/YYYY',
  label: null,
  onChange: noop,
  type: DATE_TIME_PICKER_TYPES.date,
  value: undefined,
  shouldDisableWeekends: true,
  className: undefined,
  disableCalendar: false
}

export default AvailableDatePicker
